/* RESPONSIBLE TEAM: team-proactive-support */

import Model, { attr } from '@ember-data/model';

export default class FinFooterSettings extends Model {
  @attr() declare appId: string;
  @attr() declare showFinFooter: boolean;
}
